// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"1c6c56b2","85":"baab223b","136":"4c6e1ab5","213":"2c455538","214":"ffed0c6a","239":"29af5b00","411":"6f40b729","455":"c9c8502b","461":"cc3ece4a","466":"261f15db","485":"f69de937","730":"83b7e6f2","864":"ee37b077","878":"db19e47a","925":"aeaed056"}[chunkId] + ".chunk.js";
};